import { render, staticRenderFns } from "./KD6Config.vue?vue&type=template&id=09fe459c&scoped=true"
import script from "./KD6Config.vue?vue&type=script&lang=js"
export * from "./KD6Config.vue?vue&type=script&lang=js"
import style0 from "./KD6Config.vue?vue&type=style&index=0&id=09fe459c&prod&lang=css"
import style1 from "./KD6Config.vue?vue&type=style&index=1&id=09fe459c&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "09fe459c",
  null
  
)

export default component.exports